import { gql, TypedDocumentNode } from '@common/hooks';
import {
  DecideScheduleReviewUnitMutationCgResponse,
  DecideScheduleReviewUnitMutationVariables,
} from '@common/graphql';

// Records a manager's per-unit review decision. The "Review & Mark Complete" action
// sends APPROVED for the unit in view; the run auto-completes once no unit is pending.
export const DECIDE_SCHEDULE_REVIEW_UNIT_MUTATION: TypedDocumentNode<
  DecideScheduleReviewUnitMutationCgResponse,
  DecideScheduleReviewUnitMutationVariables
> = gql`
  mutation DecideScheduleReviewUnit(
    $balancerRunId: ID!
    $organizationUnitId: ID!
    $decision: LoadBalancingScheduleReviewDecision
  ) {
    decideScheduleReviewUnit(
      balancerRunId: $balancerRunId
      organizationUnitId: $organizationUnitId
      decision: $decision
    ) {
      balancerRunId
      state
      serviceLineId
    }
  }
`;
